import { useEffect, useState } from "react";
import {
  useCallSheetState,
  setUnSavedCallSheet,
} from "../../../../hooks/callSheet";
import { Downgraded } from "@hookstate/core";

import DateTimePicker from "../../common/datePicker";
import {
  combineDateAndTime,
  formatDate,
  FormattedDate,
  formatTime,
} from "../../../../helper/converters";
import WeatherSection from "../../weather-section";
import TimeTool from "../../time-tool";

function infoCard(props: any) {
  const {
    onChange,
    zipcode,
    dayEnd,
    dayStar,
    weather,
    setDayStart,
    setDayEnd,
    setWeather,
    infoCard,
  } = props;

  const callSheetState = useCallSheetState();
  const dateCallsheet = callSheetState.date.get();
  const unsavedFlag = callSheetState.unsaved.get();
  const date = callSheetState.date.get();
  callSheetState.attach(Downgraded);
  const apiKey = "ATQ2GRAEYUK5VPKX757MYKGH5";
  const base_url =
    "https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/";

  const isDateStartValid =
    (dayStar === "" && dayEnd === "") ||
    (Number(dayEnd) >= Number(dayStar) && dayStar !== "");

  const isDateEndValid =
    (dayStar === "" && dayEnd === "") ||
    (Number(dayEnd) >= Number(dayStar) && dayEnd !== "");

  const updateDate = (date: any) => {
    callSheetState.date.set(date.toString());
  };

  const updateRangeStar = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    const value = e.target.value;
    setDayStart(value);
  };

  const updateRangeEnd = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    const value = e.target.value;
    setDayEnd(value);
  };

  const updateTime = (
    time: { hour: string; mins: string; amPm: string },
    eventStr: string
  ) => {
    const timeStr = `${time.hour}:${time.mins} ${time.amPm}`;
    onChange({ ...infoCard, [eventStr]: timeStr });
    if (!unsavedFlag) setUnSavedCallSheet(true);
  };

  useEffect(() => {
    const currentDate = FormattedDate(date);
    if (zipcode) {
      try {
        const getWeather = async () => {
          const response = await fetch(
            `${base_url}${zipcode}/${currentDate}?key=${apiKey}&contentType=json`
          );
          if (response.status === 400) {
            setWeather([]);
            throw new Error("Invalid Zip code");
          }
          const data = await response.json();
          setWeather(data.days);
        };
        getWeather();
      } catch (error) {
        setWeather([]);
      }
    }
  }, [zipcode, date]);

  return (
    <div className="card">
      <div className="card-information">
        <div className="card-information-datePicker">
          <DateTimePicker
            date={dateCallsheet}
            onChange={(e: string) => {
              updateDate(e);
            }}
          />
        </div>
        <div className="card-information-dateRange">
          <span>Day</span>
          <input
            type="text"
            maxLength={2}
            value={dayStar}
            onChange={(e) => updateRangeStar(e)}
            className={`${!isDateStartValid ? "error" : ""}`}
          />
          <span>of</span>
          <input
            type="text"
            value={dayEnd}
            maxLength={2}
            onChange={(e) => updateRangeEnd(e)}
            className={`${!isDateEndValid ? "error" : ""}`}
          />
        </div>
      </div>
      <hr className="divide-line" />
      <WeatherSection
        weather={weather}
        zipcode={zipcode}
      />
      <hr className="divide-line" />
      <div className="card-information-schedule">
        <div className="row">
          <div className="card-information-schedule event">
            <span>Breakfast</span>
          </div>
          <div className="card-information-schedule time">
            <TimeTool
              size="small"
              updateTime={(e: any, eventStr = "breakfast") =>
                updateTime(e, eventStr)
              }
              time={
                infoCard["breakfast"] && infoCard["breakfast"] !== ""
                  ? formatTime(infoCard["breakfast"])
                  : ""
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="card-information-schedule event">
            <span>Crew Call</span>
          </div>
          <div className="card-information-schedule time">
            <TimeTool
              size="small"
              updateTime={(e: any, eventStr = "crew") =>
                updateTime(e, eventStr)
              }
              time={
                infoCard["crew"] && infoCard["crew"] !== ""
                  ? formatTime(infoCard["crew"])
                  : ""
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="card-information-schedule event">
            <span>Shooting Call</span>
          </div>
          <div className="card-information-schedule time">
            <TimeTool
              size="small"
              updateTime={(e: any, eventStr = "shooting") =>
                updateTime(e, eventStr)
              }
              time={
                infoCard["shooting"] && infoCard["shooting"] !== ""
                  ? formatTime(infoCard["shooting"])
                  : ""
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="card-information-schedule event">
            <span>Lunch</span>
          </div>
          <div className="card-information-schedule time">
            <TimeTool
              size="small"
              updateTime={(e: any, eventStr = "lunch") =>
                updateTime(e, eventStr)
              }
              time={
                infoCard["lunch"] && infoCard["lunch"] !== ""
                  ? formatTime(infoCard["lunch"])
                  : ""
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="card-information-schedule event">
            <span>2nd Meal</span>
          </div>
          <div className="card-information-schedule time">
            <TimeTool
              size="small"
              updateTime={(e: any, eventStr = "meal") =>
                updateTime(e, eventStr)
              }
              time={
                infoCard["meal"] && infoCard["meal"] !== ""
                  ? formatTime(infoCard["meal"])
                  : ""
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="card-information-schedule event">
            <span>Est. Wrap</span>
          </div>
          <div className="card-information-schedule time">
            <TimeTool
              size="small"
              updateTime={(e: any, eventStr = "wrap") =>
                updateTime(e, eventStr)
              }
              time={
                infoCard["wrap"] && infoCard["wrap"] !== ""
                  ? formatTime(infoCard["wrap"])
                  : ""
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default infoCard;
